module.exports = __webpack_public_path__ + "img/Ele1.ef3477f5.jpg";